import baseSizes from '@elegantstack/flow-ui-theme/src/theme/sizes'

const sizes = {
  ...baseSizes,
  container: 1240
}

export default sizes
